/**
 * For use with KeyboardEvent.keyCode (DEPRECATED)
 * For new usages, switch to KeyboardEvent.key
 * See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
 */
export const Keys = {
  TAB: 9,
  RETURN: 13,
  ESCAPE: 27,
  SPACE: 32,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};
/**
 * For use with KeyboardEvent.key
 * See https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
 */

export const KeyStrings = {
  BACKSPACE: 'Backspace',
  DELETE: 'Delete',
  TAB: 'Tab',
  RETURN: 'Enter',
  ESCAPE: 'Escape',
  END: 'End',
  HOME: 'Home',
  SPACE: ' ',
  LEFT: 'ArrowLeft',
  UP: 'ArrowUp',
  RIGHT: 'ArrowRight',
  DOWN: 'ArrowDown'
};
//# sourceMappingURL=keys.js.map